import { LockSimpleOpenIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Unlocked = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <LockSimpleOpenIcon size={Sizes[size]} fill={fill} stroke={stroke} {...rest} />;
};

Unlocked.displayName = 'Unlocked';
